import { Box } from "@mui/material";
import { CarruselFeatured } from "../../components/CarruselFeatured";
import { EmblaHero } from "../../components/EmblaHero/EmblaHero";

export const Store = () => {
  return (
    <Box>
     <EmblaHero options={{loop: true, duration: 40}} />
      <CarruselFeatured
        to="/collections/monarch"
        sortKey="MANUAL"
        category="monarch"
      />
      <CarruselFeatured
        to="/collections/bags"
        sortKey="MANUAL"
        category="bags"
      />
      <CarruselFeatured
        to="/collections/adult-leotards"
        sortKey="MANUAL"
        category="adult-leotards"
      />
      <CarruselFeatured
        to="/collections/tutus"
        sortKey="MANUAL"
        category="tutus"
      />
      <CarruselFeatured
        to="/collections/Youth Leotards"
        sortKey="MANUAL"
        category="youth-leotards"
      />
      <CarruselFeatured
        to="/collections/pointe-shoes"
        sortKey="MANUAL"
        category="pointe-shoes"
      />
      <CarruselFeatured
        to="/collections/training-tools"
        sortKey="MANUAL"
        category="training-tools"
      />
      <CarruselFeatured
        to="/collections/warm-up-booties"
        sortKey="MANUAL"
        category="warm-up-booties"
      />
      <CarruselFeatured
        to="/collections/warm-ups"
        sortKey="MANUAL"
        category="warm-ups"
      />
    </Box>
  );
};
